import { AppContextProductType, BaseProductType, ProductType } from '@/product/constants/productTypes';
import Diamond from '@/product/entity/Diamond';
import { ProductEntity } from '@/product/types';

export enum CollectionType {
  Diamond = 1,
  Jewelry = 2,
  Rough = 3,
  Gem = 4,
}

export function toBaseProductType(collectionType: CollectionType): BaseProductType {
  if (collectionType === CollectionType.Jewelry) {
    return ProductType.Jewelry;
  }

  if (collectionType === CollectionType.Rough) {
    return ProductType.Rough;
  }

  if (collectionType === CollectionType.Gem) {
    return ProductType.Gem;
  }

  return ProductType.Diamond;
}

export function fromBaseProductType(productType: BaseProductType): CollectionType {
  if (productType === ProductType.Jewelry) {
    return CollectionType.Jewelry;
  }

  if (productType === ProductType.Rough) {
    return CollectionType.Rough;
  }

  if (productType === ProductType.Gem) {
    return CollectionType.Gem;
  }

  return CollectionType.Diamond;
}

export function toAppContextProductType(collectionType: CollectionType): AppContextProductType {
  if (collectionType === CollectionType.Jewelry) {
    return ProductType.Jewelry;
  }

  if (collectionType === CollectionType.Rough) {
    return ProductType.Rough;
  }

  if (collectionType === CollectionType.Gem) {
    return ProductType.Gem;
  }

  return ProductType.DiamondColorless;
}

export function detectProductTypeFromCollectionProducts(
  collectionType: CollectionType,
  products: ProductEntity[],
): AppContextProductType {
  const baseProductType = toAppContextProductType(collectionType);

  if (baseProductType !== ProductType.DiamondColorless) {
    return baseProductType;
  }

  return products.every((p) => p instanceof Diamond && p.isFancyColor)
    ? ProductType.DiamondFancy
    : ProductType.DiamondColorless;
}
